<template>
    <div class="grid nested-grid">
        <div class="col-12">
            <div class="card fluid cardheader agreements-header-card">
                <div class="col-12">
                    <h5 class="stationsHeader">{{ translated('receivingSupportCompanyFinancedOverviewTitle') }}</h5>
                    <div class="agreement-context mt-2">
                        <div><strong>{{ translated('companyname') }}:</strong> {{ companyName }}</div>
                        <div><strong>{{ translated('taxid') }}:</strong> {{ companyVatId }}</div>
                    </div>
                </div>
            </div>

            <div v-for="group in financedGroups" :key="group.financed.Id" class="card fluid mb-3">
                <h6 class="mb-3">{{ translated('financedName') }}: {{ group.financed.Name }}</h6>
                <div class="mb-3" v-if="group.financed.Description">
                    {{ group.financed.Description }}
                </div>

                <DataTable :value="group.agreements" class="p-datatable-sm" showGridlines responsiveLayout="scroll">
                    <template #empty>
                        No receiving agreements found.
                    </template>

                    <Column :header="translated('receivingAgreementName')" field="Name"></Column>
                    <Column :header="translated('receivingAgreementSignedDate')">
                        <template #body="slotProps">
                            {{ formatDate(slotProps.data.SignedDate) }}
                        </template>
                    </Column>
                    <Column :header="translated('receivingSupportCompanyStatus')">
                        <template #body>
                            {{ translated('linkedStatus') }}
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import createHttp from "@/services/http";
import { computed } from "vue";
import store from "@/store";

export default {
    props: ['companyId'],
    data() {
        return {
            translated: computed(() => store.getters.getTranslate),
            company: null,
            financedGroups: []
        };
    },
    async mounted() {
        await this.loadData();
    },
    computed: {
        apiBaseUrl() {
            return process.env.VUE_APP_API_FOLDER;
        },
        companyName() {
            return this.company?.Name || '';
        },
        companyVatId() {
            return this.company?.VATId || '';
        }
    },
    methods: {
        formatDate(dateTime) {
            if (!dateTime) {
                return '';
            }

            const d = new Date(dateTime);
            return d.toLocaleDateString('sl-SI', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            });
        },
        async loadData() {
            const http = createHttp(true);

            const [companiesResult, financedCompanieResult, financedResult, agreementsResult] = await Promise.all([
                http.get(this.apiBaseUrl + "/GetReceivingSupportCompanies"),
                http.get(this.apiBaseUrl + "/GetFinancedCompanieRecords"),
                http.get(this.apiBaseUrl + "/GetFinanceRecords"),
                http.get(this.apiBaseUrl + "/GetReceivingAgreements")
            ]);

            const companies = companiesResult.status === 200 ? companiesResult.data : [];
            this.company = companies.find(x => x.Id === this.companyId) || null;

            const financedCompanieRecords = financedCompanieResult.status === 200 ? financedCompanieResult.data : [];
            const financedRecords = financedResult.status === 200 ? financedResult.data : [];
            const agreements = agreementsResult.status === 200 ? agreementsResult.data : [];

            this.financedGroups = financedCompanieRecords
                .filter(x => x.ReceivingSupportCompanyId === this.companyId)
                .map(record =>
                {
                    const financed = financedRecords.find(x => x.Id === record.FinancedId) || { Id: record.FinancedId, Name: record.FinancedId };
                    const financedAgreements = agreements.filter(x => x.FinancedId === record.FinancedId && x.ReceivingSupportCompanyId === this.companyId);

                    return {
                        financed,
                        agreements: financedAgreements
                    };
                });
        }
    }
}
</script>

<style scoped>
.agreement-context {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 0.5rem 1rem;
    overflow-wrap: anywhere;
    word-break: break-word;
}

.agreements-header-card {
    height: auto;
}
</style>
